:host {
  display: block;
  list-style-type: none;
}


li {
  margin-bottom: 10px;
  padding-left: 0.7em;
  position: relative;
  @container style(--variant: square) {
    padding-left: 22px;
  }

  &::before {
    background-color: $color-black;
    content: "";
    height: 4px;
    margin: 0.6em 0 0 -0.7em;
    position: absolute;
    width: 4px;

    @container style(--variant: invisible) {
      content: unset;
    }

    @container style(--variant: square) {
      background-color: $color-green;
      height: 15px;
      left: 10px;
      top: -5px;
      width: 15px;
    }
  }
}
